"use client";

import React from "react";
import { CaseStudyData } from "../../data/case-studies/types";

interface CaseStudyTelemetryProps {
  caseStudy: CaseStudyData;
}

export function CaseStudyTelemetry({ caseStudy }: CaseStudyTelemetryProps) {
  return (
    <section className="py-24 md:py-36 border-b border-white/[0.08]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {/* Section Header */}
        <div className="mb-16 space-y-3">
          <span className="block font-mono text-xs uppercase tracking-wider text-zinc-500">
            Impact
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white">
            Operational Telemetry
          </h2>
        </div>

        {/* 3 Open Swiss Columns with 1px Hairlines */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 pt-8 border-t border-white/[0.08]">
          {caseStudy.metrics.map((metric, mIdx) => (
            <div key={mIdx} className="space-y-3">
              <span className="block font-mono text-xs text-zinc-500 tracking-wider uppercase">
                {metric.label}
              </span>
              <span className="block text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight text-white">
                {metric.value}
              </span>
              {metric.subtext && (
                <p className="text-sm sm:text-base text-zinc-400 font-light leading-relaxed pt-1">
                  {metric.subtext}
                </p>
              )}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
